import PageManager from "components/PageManager/PageManager";
import { Column, Row, TitleSection } from "components/styles";
import { RECORDS_BY_PAGE } from "../../utils/constants";
import { FiltersCard, FiltersGridWrap } from "../../styles";
import FilterButtons from "./FilterButtons";
import FilterFields from "./FilterFields";

const Header = ({
	filters,
	campusOptions,
	signatureTypeOptions,
	applyFilters,
	paginator,
	changePage,
}) => {
	const getCaption = () => {
		const { totalRecords, currentPage } = paginator.data;
		if (totalRecords === 0) {
			return "Firmas";
		}

		const startRecord = (currentPage - 1) * RECORDS_BY_PAGE + 1;
		const endRecord = Math.min(currentPage * RECORDS_BY_PAGE, totalRecords);
		return `Firmas ${startRecord} - ${endRecord} de ${totalRecords}`;
	};

	return (
		<Column gap="10px">
			<Row width="100%">
				<TitleSection>Firmas</TitleSection>
				<PageManager
					caption={getCaption()}
					isFreeCaption
					noPages={paginator.data.totalRecords === 0}
					dataPaginator={{
						...paginator.data,
						setCurrentPage: changePage,
					}}
				/>
			</Row>
			<FiltersCard>
				<FiltersGridWrap>
					<FilterFields
						filters={filters}
						campusOptions={campusOptions}
						signatureTypeOptions={signatureTypeOptions}
					/>
					<FilterButtons filters={filters} applyFilters={applyFilters} />
				</FiltersGridWrap>
			</FiltersCard>
		</Column>
	);
};

export default Header;
